export default __webpack_public_path__ + "images/7ffef12e85640cb7dafd2d61946a050c-aetheism.webp";